export default __webpack_public_path__ + "static/media/blog-post-layout-05-img-02.cd3da6d5.jpg";